import React from 'react';
import useCreateImportForm
    from "v4/pages/admin/Import/components/ImportSteps/components/CreateImport/components/CreateImportForm/hooks/useCreateImportForm";
import {FormProvider} from "react-hook-form";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import FieldWrapper from "v4/components/form/FieldWrapper/FieldWrapper";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";

const FIELDS_TO_RENDER = [
    {name: 'entityType', props: {}},
    {name: 'csvFile', props: {isLabelActive: true}},
    {name: 'delimiter', props: {}},
    {name: 'csvTextEncapsulation', props: {}},
    {name: 'csvMultiValuesDelimiter', props: {}},
];

export default function CreateImportForm() {
    const {t} = usePolTranslation();
    const {
        isFormLoading,
        formMethods,
        onSubmit,
        importFormInputs,
        isSubmitLoading,
    } = useCreateImportForm();

    if (isFormLoading || !importFormInputs) return <InlineLoader/>;

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                {FIELDS_TO_RENDER.map((field) => (
                    importFormInputs[field.name] && (
                        <FieldWrapper field={importFormInputs[field.name]}
                                      name={field.name}
                                      key={field.name}
                                      {...field.props}/>
                    )
                ))}

                <div className="d-flex justify-content-end">
                    <SubmitButton isLoading={isSubmitLoading}>
                        {t('send_mail')}
                    </SubmitButton>
                </div>
            </form>
        </FormProvider>
    )
}
